'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slick = void 0;
const $ = require("jquery");
require("slick-carousel");
class Slick {
    constructor() {
        const self = this;
        $('.bulletWorksSlider').slick({
            infinite: true,
            dots: false,
            arrows: false,
            adaptiveHeight: true,
            slidesToShow: 1,
            slidesToScroll: 1,
        })
            .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            self.changeWorksTab(nextSlide);
        });
        $('.trigWorksSlider').on('click', function () {
            // クリックされたリストのインデックスを取得
            const index = $(this).index();
            $(".trigWorksSlider").addClass("active");
            // 対応するスライドに移動
            $('.bulletWorksSlider').slick('slickGoTo', index, true);
            self.changeWorksTab(index);
        });
    }
    // タブの切替
    changeWorksTab(index) {
        $('.trigWorksSlider').removeClass('active');
        $('.trigWorksSlider').eq(index).addClass('active');
    }
}
exports.Slick = Slick;
exports.default = Slick;
